"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertRadioButtonResponsesWithOldDataSourceValue = exports.assertRadioButtonResponsesWithDisplayConditions = exports.assertRadioButtonResponsesWithDataSources = void 0;
function assertRadioButtonResponsesWithDataSources(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(3);
    var customResponse = responses.find(function (r) { return r.questionId === 1195403; });
    expect(customResponse.answer).toBe("Option 1");
    expect(customResponse.associatedId).toBe(1195551);
    expect(customResponse.associatedRootId).toBe(1195551);
    expect(customResponse.questionId).toBe(1195403);
    expect(customResponse.questionRootId).toBe(1195403);
    var colorResponse = responses.find(function (r) { return r.questionId === 1195202; });
    expect(colorResponse.answer).toBe("Blue");
    expect(colorResponse.associatedId).toBe(1190205);
    expect(colorResponse.associatedRootId).toBeUndefined();
    expect(colorResponse.questionId).toBe(1195202);
    expect(colorResponse.questionRootId).toBe(1195202);
    var locationResponse = responses.find(function (r) { return r.questionId === 1195401; });
    expect(locationResponse.answer).toBe("502 JUNCTION");
    expect(locationResponse.associatedId).toBe(26986);
    expect(locationResponse.associatedRootId).toBeUndefined();
    expect(locationResponse.questionId).toBe(1195401);
    expect(locationResponse.questionRootId).toBe(1195401);
    expect(locationResponse.associatedLocation).toBeUndefined();
}
exports.assertRadioButtonResponsesWithDataSources = assertRadioButtonResponsesWithDataSources;
function assertRadioButtonResponsesWithDisplayConditions(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(12);
    var colorsResponse = responses.find(function (r) { return r.questionId === 1227151; });
    expect(colorsResponse.answer).toBe("Green");
    expect(colorsResponse.associatedId).toBe(1190204);
    expect(colorsResponse.questionId).toBe(1227151);
    expect(colorsResponse.questionRootId).toBe(1227151);
    var participantResponse = responses.find(function (r) { return r.questionId === 1227152; });
    expect(participantResponse.answer).toBe("Green");
    expect(participantResponse.questionId).toBe(1227152);
    expect(participantResponse.questionRootId).toBe(1227152);
    var multiSelectResponse = responses.find(function (r) { return r.questionId === 1227153; });
    expect(multiSelectResponse.answer).toBe("Green");
    expect(multiSelectResponse.questionId).toBe(1227153);
    expect(multiSelectResponse.questionRootId).toBe(1227153);
    var customMultiSelectResponse = responses.find(function (r) { return r.questionId === 1227457; });
    expect(customMultiSelectResponse.answer).toBe("green");
    expect(customMultiSelectResponse.questionId).toBe(1227457);
    expect(customMultiSelectResponse.questionRootId).toBe(1227457);
    expect(customMultiSelectResponse.associatedId).toBe(1227703);
    expect(customMultiSelectResponse.associatedRootId).toBe(0);
    var radioResponse = responses.find(function (r) { return r.questionId === 1227452; });
    expect(radioResponse.answer).toBe("Green");
    expect(radioResponse.questionId).toBe(1227452);
    expect(radioResponse.questionRootId).toBe(1227452);
    var dropdownResponse = responses.find(function (r) { return r.questionId === 1227155; });
    expect(dropdownResponse.answer).toBe("Green");
    expect(dropdownResponse.questionId).toBe(1227155);
    expect(dropdownResponse.questionRootId).toBe(1227155);
    var textLineResponse = responses.find(function (r) { return r.questionId === 1227453; });
    expect(textLineResponse.answer).toBe("Green");
    expect(textLineResponse.questionId).toBe(1227453);
    expect(textLineResponse.questionRootId).toBe(1227453);
    var textAreaResponse = responses.find(function (r) { return r.questionId === 1227454; });
    expect(textAreaResponse.answer).toBe("Green");
    expect(textAreaResponse.questionId).toBe(1227454);
    expect(textAreaResponse.questionRootId).toBe(1227454);
}
exports.assertRadioButtonResponsesWithDisplayConditions = assertRadioButtonResponsesWithDisplayConditions;
function assertRadioButtonResponsesWithOldDataSourceValue(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(1);
    var colorResponse = responses.find(function (r) { return r.questionId === 1195202; });
    expect(colorResponse.answer).toBe("Cherry");
    expect(colorResponse.associatedId).toBe(1190000);
    expect(colorResponse.associatedRootId).toBeUndefined();
    expect(colorResponse.questionId).toBe(1195202);
    expect(colorResponse.questionRootId).toBe(1195202);
}
exports.assertRadioButtonResponsesWithOldDataSourceValue = assertRadioButtonResponsesWithOldDataSourceValue;
//# sourceMappingURL=radioButtonResponses.js.map